import { render, staticRenderFns } from "./ShopifyFlowSettings.vue?vue&type=template&id=6261c9f1&scoped=true"
import script from "./ShopifyFlowSettings.vue?vue&type=script&lang=ts"
export * from "./ShopifyFlowSettings.vue?vue&type=script&lang=ts"
import style0 from "./ShopifyFlowSettings.vue?vue&type=style&index=0&id=6261c9f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6261c9f1",
  null
  
)

export default component.exports